import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsuarioEmpresaEditarComponent } from './usuario-empresa-editar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: UsuarioEmpresaEditarComponent}
  ])],
  exports: [RouterModule]
})
export class UsuarioEmpresaEditarRoutingModule { }
